import React from "react";
import Slider from "react-slick";
import { Grid2,Paper, Typography} from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import "../Home.css"
import { HomePopularDesktop } from "./HomePopularDesktop";

const imgData = ["pepper", "star", "allspices", "allspies","SpicesPowder","Star-Anise","Ginger","SpicesCombo","MainSpices","cardamom","Cloves","Raw-Pepper","cinnamon","fenugreek","RedChilli","GreenChilli","Rice","ChittiMuthuallu","BengalGram","PigeonPeas","GreenGram","BlackGram","Chickpeas","KidneyBeans","RedLentils"]

export const HomeDesktopView = () => {
  const settings = {
    dots: false, infinite: true, speed: 500, slidesToShow: 1, slidesToScroll: 1, initialSlide: 0,autoplay: true,autoplaySpeed: 2000,
    nextArrow :<KeyboardArrowRightIcon sx={{display:"block !important",fontSize:"70px !important",color:"#fff",zIndex:"999",right:"0px !important",opacity:"0.5","&:hover":{color:"#fff",opacity:"1",transition:"0.5s"}}}/>,
    prevArrow :<KeyboardArrowLeftIcon sx={{fontSize:"70px !important", color:"#fff",zIndex:"999",left:"0px !important",opacity:"0.5","&:hover":{color:"#fff",opacity:"1",transition:"0.5s"}}}/>,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: false, dots: false } },
      { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2, initialSlide: 2, dots: false } },
      { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1, dots: false } }
    ]
  };

  return (
    <>
      <Grid2 className="info" display="flex" component={Paper} elevation={8} width="100%" height="55vh" sx={{position:"relative",marginBottom:"2rem", "& .slick-slide img": {objectFit: "cover"},"& .slick-slider" : {width:"100%"},}}>
          <Grid2 className="Herotext">
              <Typography variant="h4" sx={{color:"#fff"}} >Welcome to GBG</Typography>
              <Typography variant="h3" sx={{color:"#E0E0E0"}} >Grow Beyond Global</Typography>  
              <Typography variant="h2" sx={{color:"#FFD700"}} >Food Imports & Exports</Typography>
              <Typography sx={{color:"#FFD700"}} >Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nisi repellendus dolor!!!!</Typography>
          </Grid2>
          <Slider {...settings} >
            {imgData.map((item,i) => {
              return(<Grid2 sx={{width:"100%",height:"55vh",backgroundImage: `linear-gradient(45deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${require(`../../../assets/Home/${item}.jpg`)})`,backgroundSize: "cover",backgroundPosition: "center"}}>
                  
                    </Grid2>
              )})}
            </Slider> 
      </Grid2>

      <Grid2 className="info" container justifyContent="center" sx={{width:"100%",position:"relative",gap:"20px"}}>
        <Typography className="headingdata">GBG - Global Food Importers & Exporters</Typography>
        <Grid2 width="90%" sx={{padding:"10px",margin:"10px 0px "}} >
            <Typography className="contentData">"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dicta, ratione sint. Similique mollitia facere perspiciatis, repellat placeat corporis ex earum quia excepturi! Neque alias qui eveniet veritatis doloribus earum quia! Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit quibusdam sequi nihil est quaerat placeat officiis nam officia, exercitationem rem ex esse quo eum corrupti nobis fugiat laudantium aliquid quam."</Typography>
        </Grid2>
      </Grid2>

      <Grid2 className="info" container justifyContent="center" sx={{width:"100%",position:"relative",gap:"20px"}}>
        <Typography className="headingdata" >Our Popular Products</Typography>
        <Grid2 container spacing={.5} width="90%"  justifyContent="flex-start" columns={20}>
        {imgData.map((item, i) => (
          <Grid2 size={{xl:2.80,lg:4,md:5}} className="mainContainer">
                            <Grid2 component={Paper} elevation={8}  className="flipCard" sx={{transformStyle:"preserve-3d !important"}}> 
                              <Grid2 className="Cardfront">
                                  <Grid2 container className="imgcontainer" height="80%" width="100%">
                                   <img src={require(`../../../assets/Home/${item}.jpg` )} alt={item} style={{ objectFit: "cover", width: "95%", height: "95%", borderRadius: "12px" }}  />
                                  </Grid2>
                                  <Typography className="Cardtext">{item}</Typography>
                              </Grid2>
                              <Grid2 className="Cardback">
                                  <Typography className="Cardtext" sx={{color:"#fff !important"}}>{item}</Typography>
                                  <Grid2 container className="imgcontainer" width="100%">
                                   <Typography sx={{textAlign:"justify",fontSize:"13px"}}> Lorem ipsum, dolor sit amet consectetur adipisicing elit. Laborum ea, commodi blanditiis porro facilis velit ab ipsam? Nulla eligendi a magnam at id maxime dicta perferendis, corporis cum, sit libero. Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis itaque accusamus voluptates sed! Quaerat iusto quos doloremque.</Typography>
                                  </Grid2>
                              </Grid2>
                            </Grid2>
                          </Grid2>
        ))}
        </Grid2>
        <Grid2 className="info" container justifyContent="center" sx={{width:"100%",position:"relative",gap:"20px"}}>
        <Typography className="headingdata">GBG - Global Food Importers & Exporters</Typography>
        <Grid2 width="90%" sx={{padding:"10px",margin:"10px 0px "}} >
            <Typography className="contentData">"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dicta, ratione sint. Similique mollitia facere perspiciatis, repellat placeat corporis ex earum quia excepturi! Neque alias qui eveniet veritatis doloribus earum quia! Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit quibusdam sequi nihil est quaerat placeat officiis nam officia, exercitationem rem ex esse quo eum corrupti nobis fugiat laudantium aliquid quam."</Typography>
        </Grid2>
      </Grid2>
        <HomePopularDesktop/>
      </Grid2>
    </>
  );
};